<fw-toolbar (toggledSidebar)="sidenavOpen = true"></fw-toolbar>

<fw-sidenav
  [open]="sidenavOpen"
  (openedChange)="sidenavOpen = $event"
></fw-sidenav>
